$(document).ready(function() {
    console.log('hello from tako');
    //$('.shopify-section--testimonials .item-content').matchHeight();

    matchHeightTestimonials();


    var $iconItemSlider = $('#iconCarousel');
    $iconItemSlider.flickity({
        prevNextButtons: false,
        pageDots: true,
        watchCSS: true
    });
    var $linkBlockSlider = $('#linkBlockCarousel');
    $linkBlockSlider.flickity({
        prevNextButtons: false,
        pageDots: true,
        watchCSS: true
    });
    var $testimonialsHomeSlider = $('#testimonialsHomeCarousel');
    $testimonialsHomeSlider.flickity({
        prevNextButtons: false,
        pageDots: true,
        watchCSS: true
    });
    var $logosHomeSlider = $('#logosHome');
    $logosHomeSlider.flickity({
        cellAlign: 'left',
        prevNextButtons: true,
        pageDots: false,
        autoPlay: true,
        wrapAround: true
    });

    $('.product-accordion-wrapper .accordion-icon').on('click', function() {
        let iconAction = $(this).attr('class');
        let allAccordions = $('.product-accordion-wrapper .accordion');
        let currentAccordion = $(this).closest('.accordion');
        let currentPanel = $(currentAccordion).next();
        let allPanels = $('.product-accordion-wrapper .panel');
        $(allAccordions).removeClass('active-accordion');
        $(allPanels).removeClass('active-panel')


        if (iconAction.includes('plus')) {
            $(currentAccordion).addClass('active-accordion')
            $(currentPanel).addClass('active-panel')
        }
    });

});

$(window).on('resize', function() {
    console.log('window resize');
    matchHeightTestimonials();
});


function matchHeightTestimonials() {
    console.log('matchHeightTestimonials');
    var maxTestimonialHeight = 0;
    $('.shopify-section--testimonials .item-content').each(function() {
        $(this).css('height', '');
    });
    $('.shopify-section--testimonials .item-content').each(function() {
        maxTestimonialHeight = Math.max(maxTestimonialHeight, $(this).height());
    });
    $('.shopify-section--testimonials .item-content').each(function() {
        $(this).height(maxTestimonialHeight);
    });
}